/**
 * Created by neo on 28.05.17.
 */

import {observable} from 'mobx';
import TimeRange from '../TimeRange';
import DateRange from '../DateRange';

export default class Availability {
  dateRange: DateRange;
  daysOfWeek: {
    ['MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY']: Array<TimeRange>
  };

  dayOfWeek(n: integer): string{
    switch (n) {
      case 1: return 'MONDAY';
      case 2: return 'TUESDAY';
      case 3: return 'WEDNESDAY';
      case 4: return 'THURSDAY';
      case 5: return 'FRIDAY';
      case 6: return 'SATURDAY';
      case 7: return 'SUNDAY';
    }

    return 'MONDAY';
  }

  constructor(json?: any) {
    if(json) {
      this.dateRange = new DateRange(json);
      this.daysOfWeek = observable.map(json.day_of_week ? { [this.dayOfWeek(json.day_of_week)]: new TimeRange(json)} : {});
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/FlightOffer/Availability.js